import { Box, capitalize, SelectChangeEvent, Slider, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import InputSelect from "../global/select";
import React from "react";
import { pxToRem } from "@/util";

type selectProps={
    name:string;
    placeholder:string;
    data:{label:string; value:string}[],
    handleChange: (event: SelectChangeEvent) => void;
    value:string;
}

type chipProps={
    name:string;
    setPropertyType:(value:string)=>void;
    data:{label:string; isSelected:boolean}[],
    
}

export const FiltSelect=({name,placeholder,handleChange,value="",data}:Partial<selectProps>)=>{
    const {classes}=styles();
    return(
    <Box className={classes.select}>
        <Typography className={classes.name}>
         {name}
        </Typography>
        <InputSelect 
         placeholder={placeholder}
         handleChange={handleChange} 
         value={value}
         data={data}
         />
    </Box>
    )
}
 

export const FiltChip=({name,data,setPropertyType}:Partial<chipProps>)=>{
    const [chips, setChips] = React.useState<{ label: string; isSelected: boolean }[]>(data ?? []);
    const handleSelect=(key:number)=>{
           setChips((prev)=>prev.map((item:{label:string;isSelected:boolean},index:number)=>
            index===key?{...item,isSelected:true}:{...item,isSelected:false}
        ));
        if(setPropertyType)setPropertyType(chips[key].label);
    }
     const {classes}=styles();
    return(
    <Box>
        <Typography className={classes.name}>
         {name}
        </Typography>
      <Box className={classes.chipcont}>
          {chips.map((item:{label:string;isSelected:boolean},key:number)=>
            <Box onClick={()=>handleSelect(key)} key={item.label} sx={{backgroundColor:item?.isSelected?'#E5E5E5':'#F5F5F5',borderRadius:'8px',padding:'4px 8px',margin:'4px'}}>
                <Typography style={{fontStyle:'capitalize'}}>
                    {capitalize(item.label)}
                </Typography>
            </Box>
        )}
      </Box>
    </Box>
    )
}

function valuetext(value: number) {
  return `${value}°C`;
}
type props={
    name:string
}
export const FiltRange=({name}:props)=> {
  const [value, setValue] = React.useState<number[]>([20, 37]);

  const handleChange = (event: Event, newValue: number[]) => {
    setValue(newValue);
  };
const {classes}=styles();
  return (
    
      <Box>
        <Typography className={classes.name}>{name}</Typography>
        <Slider
        getAriaLabel={() => 'Temperature range'}
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        getAriaValueText={valuetext}
      />
      </Box>

  );
}
const styles=makeStyles()((theme)=>({
name:{
fontWeight: 500,
fontSize:pxToRem(20),

},
select:{
    width:'100%',
},
chipcont:{
    display:'flex',
    flexDirection:'row',
    gap:theme.spacing(2),
    overflowY:'scroll'
}
}))